// Nette.ajax.js for AJAX submit forms
import '../../../../../tools/node_modules/nette.ajax.js/nette.ajax';
import '../../../../../tools/node_modules/nette.ajax.js/extensions/spinner.ajax';

/** Rewrite Nette validation modal window.*/
// Nette.showModal = function(message, onclose) {};
$.nette.init();